import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BookModal = ({product}) => {
  const [modal, setModal] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [quantity, setQuantity] =useState(0)
  // console.log(startDate)


  const toggle = () => setModal(!modal);
  
  const onChangeStartDate = (e) => {
    setStartDate(e)
  }

  const onChangeEndDate = (e) => {
    setEndDate(e)
  }

  const bookNow = (e, product) => {

    const diffTime = endDate.getTime() - startDate.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24))
    let days = diffDays

    let cartItems = JSON.parse(localStorage.getItem('cartItems'))
    if(cartItems.length){
      let matched = cartItems.find(item => {
        return item._id === product._id
      })

      if(matched){
        let updatedCart = cartItems.map(item=>{

          return item._id === product._id ?
          {...item, quantity: item.quantity += parseInt(e.target.previousElementSibling.value), days} : item
        })
        localStorage.setItem('cartItems', JSON.stringify(updatedCart))
      } else {
        cartItems.push({...product, quantity, days})
      }
    } else {
      cartItems.push({...product, quantity, days})
    }
    localStorage.setItem('cartItems', JSON.stringify(cartItems))
    window.location.href="/tours"
  }
  
  return (
    <div>
      <Button color="info" onClick={toggle} className="btn-block">Book</Button>
      <div>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} className="text-center">Booking Details</ModalHeader>

            <ModalBody className="d-flex justify-content-center">
                    <div className="row">
                      <div className="col">

                        <div className="form-inline">
                          <label className="col-sm-4">Start Date:</label>
                          <div className="col-sm-8">
                            <DatePicker selected={startDate} onChange={onChangeStartDate} className="form-control text-center" />
                          </div>
                        </div>

                        <div className="form-inline my-3">
                          <label className="col-sm-4">End Date:</label>
                          <div className="col-sm-8">
                            <DatePicker selected={endDate} onChange={onChangeEndDate} className="form-control text-center" />
                          </div>
                        </div>

                        <div className="form-inline">
                          <label className="col-sm-4">Person:</label>
                          <div className="col-sm-8">
                            <input type="number" placeholder="input number" className="form-control text-center" onChange={(e) => setQuantity(parseInt(e.target.value))} />
                          </div>
                        </div>

                      </div>
                    </div>
            </ModalBody>

            <ModalFooter>
            <form>
              <Button color="info" onClick={(e) => bookNow(e, product)}>Book Now</Button>{' '}
            </form>
              <Button color="danger" onClick={toggle}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
    </div>
  );
}

export default BookModal;